import React from 'react';
import styled from 'styled-components';

import { BreadCrumbType } from '@/typings/common';
import BreadCrumb from '@/components/BreadCrumb';
import Title from '@/components/BlogSharedHeader/components/Top/Title';

type Props = {
  breadCrumbs: BreadCrumbType[];
  pageTitle: string;
};

const TopView = ({ breadCrumbs, pageTitle }: Props) => {
  return (
    <Component>
      <BreadCrumb breadCrumbs={breadCrumbs} />
      <Title title={pageTitle} />
    </Component>
  );
};

export default TopView;
const Component = styled.div``;
